import { mapRange } from '@wix/wow-utils';
import { getCssUnits, getMouseTransitionEasing, } from '../../../utils/animationsUtils';
export const name = 'AiryMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, distance = { value: 200, type: 'px' }, angle = 30, axis = 'both', transitionDuration, transitionEasing = 'linear', } = {}) {
    const element = elements[0];
    const invert = inverted ? -1 : 1;
    if (transitionDuration) {
        element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasing(transitionEasing)}`;
    }
    return {
        progress({ x: progressX, y: progressY }) {
            let translateX = 0;
            let translateY = 0;
            if (axis !== 'vertical') {
                translateX =
                    mapRange(0, 1, -distance.value, distance.value, progressX) * invert;
            }
            if (axis !== 'horizontal') {
                translateY =
                    mapRange(0, 1, -distance.value, distance.value, progressY) * invert;
            }
            // if progress  === 0, rotate === angle, if progress === 0.5, rotate === 0, if progress === 1, rotate === angle
            const rotate = mapRange(0, 1, -angle, angle, progressX) * invert;
            const units = getCssUnits(distance.type);
            const transform = `translateX(${translateX}${units}) translateY(${translateY}${units}) rotate(calc(${rotate}deg + var(--comp-rotate-z, 0deg)))`;
            element.style.transform = transform;
        },
        kill() {
            element.style.transform = '';
            element.style.transition = '';
        },
    };
}
//# sourceMappingURL=airyMouse.js.map